import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector, change } from "redux-form";
import _ from "lodash";
import { Link, browserHistory } from "react-router";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";
import { ANALISE_IMAGEM_ALL_COMPANIES_LOAD, ANALISE_IMAGEM_ALL_FINANCIAL_LOAD, CONFIRM_ACTION_OPEN } from "../../actions/Constants";

import api from "../../api/apiUtil";
import SelectField from "../../components/Fields/SelectField";
import FieldValidation from "../../components/Validation/FieldValidation";
import FreeTagField from "../../components/Fields/FreeTagField";
import DropdownListField from "../../components/Fields/DropdownListField";

const palavrasDinamicas = [
  { label: "Nome Devedor", value: "%devNome" },
  { label: "Doc. Devedor", value: "%devCpfCnpj" },
  { label: "Chassi", value: "%chassi" },
  { label: "Núm. Contrato", value: "%numero" },
  { label: "Renavam", value: "%renavam" },
  { label: "Núm. Gravame", value: "%numGravame" },
];

class ConfigurarPalavras extends React.Component {
  constructor(props) {
    super(props);
    this.addPalavraDinamica = this.addPalavraDinamica.bind(this);
    this.addPalavraDinamicaFinanceira = this.addPalavraDinamicaFinanceira.bind(this);
    this.handleFinanceiraChange = this.handleFinanceiraChange.bind(this);
    this.handleCancelGeral = this.handleCancelGeral.bind(this);
    this.handleCancelFinanceira = this.handleCancelFinanceira.bind(this);
    this.handleSubmitGeral = this.handleSubmitGeral.bind(this);
    this.handleSubmitFinanceira = this.handleSubmitFinanceira.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
  }

  componentWillMount() {
    if (this.props.currentUser.perfis.some((item) => item == "ALIAS")) {
      this.props.onCompaniesLoad(api.Financial.allFinancial());
    }
    this.props.onFinancialLoad(api.Configuracao.getFinanceirasCustomizadas());

    Promise.resolve(api.Configuracao.getPalavrasPadrao())
      .then((result) => {
        if (result && result.length > 0 && result[0].palavras) {
          try {
            // Converter a string JSON para array
            const palavrasArray = JSON.parse(result[0].palavras);

            // Converter o array de strings para o formato esperado pelo FreeTagField
            const palavrasFormatadas = palavrasArray.map((palavra) => ({
              value: palavra,
              label: palavra,
            }));

            // Atualizar o campo camposFixos com as palavras carregadas
            this.props.dispatch(change("ConfigurarPalavrasForm", "camposFixos", palavrasFormatadas));
          } catch (error) {
            toastr.error("Erro", "Não foi possível carregar a configuração geral.");
          }
        }
      })
      .catch((error) => {
        if (error.message === "Unauthorized" || error.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  componentDidUpdate(prevProps) {
    // Se a financeira foi desselecionada, limpar os campos relacionados
    if (prevProps.finSelected && !this.props.finSelected) {
      this.props.dispatch(change("ConfigurarPalavrasForm", "camposFinanceira", []));
      this.props.dispatch(change("ConfigurarPalavrasForm", "financeiraDesabilitada", null));
    }
  }

  addPalavraDinamica(palavra) {
    const { dispatch, camposFixos } = this.props;

    // Verifica se o campo já existe na lista
    const currentValues = camposFixos || [];
    const exists = currentValues.some((item) => item.value === palavra.value || item.label === palavra.value);

    if (!exists) {
      // Adiciona a palavra ao campo FreeTagField
      const updatedValues = [
        ...currentValues,
        {
          value: palavra.value,
          label: palavra.value,
          isDinamica: true, // Marca como palavra dinâmica
        },
      ];
      dispatch(change("ConfigurarPalavrasForm", "camposFixos", updatedValues));
    } else {
      toastr.warning("Atenção", "Esta palavra já foi adicionada.");
    }
  }

  // Método para adicionar palavras dinâmicas à configuração específica da financeira
  addPalavraDinamicaFinanceira(palavra) {
    const { dispatch, camposFinanceira, finSelected } = this.props;

    // Verifica se uma financeira foi selecionada
    if (!finSelected) {
      toastr.warning("Atenção", "Selecione uma financeira primeiro.");
      return;
    }

    // Verifica se o campo já existe na lista
    const currentValues = camposFinanceira || [];
    const exists = currentValues.some((item) => item.value === palavra.value || item.label === palavra.value);

    if (!exists) {
      // Adiciona a palavra ao campo FreeTagField
      const updatedValues = [
        ...currentValues,
        {
          value: palavra.value,
          label: palavra.value,
          isDinamica: true, // Marca como palavra dinâmica
        },
      ];
      dispatch(change("ConfigurarPalavrasForm", "camposFinanceira", updatedValues));
    } else {
      toastr.warning("Atenção", "Esta palavra já foi adicionada.");
    }
  }

  handleFinanceiraChange(value) {
    // Se a financeira for desselecionada, limpar os campos relacionados
    if (!value || (this.props.finSelected && value.id != this.props.finSelected.id)) {
      this.props.dispatch(change("ConfigurarPalavrasForm", "camposFinanceira", []));
      this.props.dispatch(change("ConfigurarPalavrasForm", "financeiraDesabilitada", false));
    }
    // Se uma financeira for selecionada, carregar sua configuração
    this.carregarConfiguracaoFinanceira(value.id);
  }

  carregarConfiguracaoFinanceira(idFinanceira) {
    if (!idFinanceira) return;

    Promise.resolve(api.Configuracao.getPalavrasFinanceira(idFinanceira))
      .then((result) => {
        if (result && result.length > 0) {
          try {
            // Atualizar o status da financeira
            this.props.dispatch(change("ConfigurarPalavrasForm", "financeiraDesabilitada", result[0].status));

            // Se houver palavras, processar e atualizar o campo
            if (result[0].palavras) {
              const palavrasArray = JSON.parse(result[0].palavras);
              const palavrasFormatadas = palavrasArray.map((palavra) => ({
                value: palavra,
                label: palavra,
              }));
              this.props.dispatch(change("ConfigurarPalavrasForm", "camposFinanceira", palavrasFormatadas));
            }
          } catch (error) {
            toastr.error("Erro", "Não foi possível carregar a configuração da financeira.");
          }
        }
      })
      .catch((error) => {
        if (error.message === "Unauthorized" || error.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  // Método para limpar apenas os campos da configuração geral
  handleCancelGeral() {
    const { dispatch } = this.props;
    dispatch(change("ConfigurarPalavrasForm", "camposFixos", []));
  }

  // Método para limpar apenas os campos da configuração específica da financeira
  handleCancelFinanceira() {
    const { dispatch } = this.props;
    dispatch(change("ConfigurarPalavrasForm", "financeiraSel", null));
    dispatch(change("ConfigurarPalavrasForm", "camposFinanceira", []));
    dispatch(change("ConfigurarPalavrasForm", "financeiraDesabilitada", null));
  }

  handleSubmitGeral() {
    const { camposFixos } = this.props;

    if (!camposFixos || camposFixos.length === 0) {
      toastr.warning("Erro", "É necessário informar pelo menos uma palavra para análise.");
      return;
    }

    // Extrai apenas os valores das palavras
    const palavras = camposFixos.map((item) => item.value || item.label);

    const dadosGeral = {
      palavras: JSON.stringify(palavras),
    };

    Promise.resolve(api.Configuracao.postPalavrasConfiguradas(dadosGeral))
      .then((ret) => {
        toastr.success("Sucesso", "Configuração geral salva com sucesso!");
      })
      .catch((error) => {
        if (error.message === "Unauthorized" || error.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleSubmitFinanceira() {
    const { finSelected, camposFinanceira, financeiraDesabilitada } = this.props;

    // Validação: financeira é obrigatória
    if (!finSelected) {
      toastr.warning("Erro", "É necessário selecionar uma financeira.");
      return;
    }

    // Validação: se status for 0 (habilitado), palavras são obrigatórias
    if (!financeiraDesabilitada && (!camposFinanceira || camposFinanceira.length === 0)) {
      toastr.warning("Erro", "É necessário informar pelo menos uma palavra para análise quando a financeira está habilitada.");
      return;
    }

    // Extrai apenas os valores das palavras
    const palavras = Array.isArray(camposFinanceira) ? camposFinanceira.map((item) => item.value || item.label) : [];

    const dadosFinanceira = {
      idFinanceira: finSelected.id,
      palavras: palavras.length > 0 ? JSON.stringify(palavras) : null,
      status: !financeiraDesabilitada ? "0" : parseInt(financeiraDesabilitada),
    };

    Promise.resolve(api.Configuracao.postPalavrasConfiguradas(dadosFinanceira))
      .then((ret) => {
        this.props.onFinancialLoad(api.Configuracao.getFinanceirasCustomizadas());
        toastr.success("Sucesso", "Configuração da financeira salva com sucesso!");
      })
      .catch((error) => {
        if (error.message === "Unauthorized" || error.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleOnCancel = () => {
    browserHistory.goBack();
  };

  onDelete(financial) {
    return () => {
      this.props.onActionOpen({
        description: `Confirma Excluir a Customização para a Financeira ${financial.razaoSocial}?`,
        onSuccess: () => this.handleOnDelete(financial),
      });
    };
  }

  handleOnDelete(financial) {
    var props = this.props;

    Promise.resolve(api.Configuracao.delFinanceiraCustomizada(financial.idFinanceira))
      .then((resp) => {
        toastr.success("Sucesso", "Customização excluída com sucesso!");
        this.props.onFinancialLoad(api.Configuracao.getFinanceirasCustomizadas());
      })
      .catch((error) => {
        if (error === "Unauthorized" || error === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  render() {
    const { handleSubmit, reset } = this.props;
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Configuração de Palavras a Serem Analisadas nas Imagens" />{" "}
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    <Link className="btn btn-sm btn-default" style={{ margin: "0 2px" }} onClick={browserHistory.goBack}>
                      <i className="fas fa-arrow-left"></i> Voltar{" "}
                    </Link>
                  </div>
                  {this.props.currentUser.perfis.some((item) => item == "ALIAS") && `Configuração Geral (Padrão)`}
                </div>
                {this.props.currentUser.perfis.some((item) => item == "ALIAS") && (
                  <div className="panel-body">
                    <form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        this.handleSubmitGeral();
                      }}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <Field name="camposFixos" label="Palavras a Serem Analisadas" component={FreeTagField} type="text" validate={[FieldValidation.required]} />
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="font-weight-bold">Palavras Dinâmicas Disponíveis</label>
                            <p className="text-muted small">Clique em uma palavra para adicioná-la à lista de palavras a serem analisadas.</p>
                            <div>
                              {palavrasDinamicas.map((palavra, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  className="btn btn-sm btn-outline-info mr-2 mb-2"
                                  onClick={() => this.addPalavraDinamica(palavra)}
                                  title={`Adicionar ${palavra.label}`}
                                >
                                  {palavra.label} ({palavra.value})
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="text-right">
                            <button type="button" className="btn btn-default" onClick={this.handleCancelGeral}>
                              {" "}
                              Cancelar
                            </button>
                            <button className="btn btn-info" type="submit">
                              Salvar
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                <div className="panel-heading">Configurar Palavras Específicas para Financeira</div>

                <div className="panel-body">
                  <form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.handleSubmitFinanceira();
                    }}
                  >
                    <div className="row">
                      <div className="col-md-5">
                        {this.props.currentUser.perfis.some((item) => item == "ALIAS") ? (
                          <Field
                            name="financeiraSel"
                            label="Financeira"
                            blank={true}
                            data={this.props.allCompanies}
                            textField="razaoSocialCnpj"
                            valueField="id"
                            component={DropdownListField}
                            type="text"
                            required
                            credor={true}
                            onChange={this.handleFinanceiraChange}
                          />
                        ) : (
                          <Field
                            name="financeiraSel"
                            label="Financeira"
                            blank={true}
                            data={this.props.companies}
                            textField="razaoSocial"
                            valueField="id"
                            component={DropdownListField}
                            type="text"
                            required
                            credor={true}
                            onChange={this.handleFinanceiraChange}
                          />
                        )}
                      </div>

                      <div className="col-md-2">
                        <Field
                          name="financeiraDesabilitada"
                          label="Desabilitar Análise"
                          blank={false}
                          data={[
                            { id: 0, desc: "Não" },
                            { id: 1, desc: "Sim" },
                          ]}
                          component={SelectField}
                          type="text"
                          textField="desc"
                          valueField="id"
                          textTooltip="Marque esta opção para desabilitar a análise de imagens para esta financeira"
                          disabled={!this.props.finSelected}
                        />
                      </div>
                    </div>
                    {parseInt(this.props.financeiraDesabilitada) !== 1 && (
                      <div className="row">
                        <div className="col-md-3">
                          <Field
                            name="camposFinanceira"
                            label="Palavras a Serem Analisadas"
                            component={FreeTagField}
                            type="text"
                            validate={[FieldValidation.required]}
                            disabled={!this.props.finSelected}
                          />
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className="font-weight-bold">Palavras Dinâmicas Disponíveis</label>
                            <p className="text-muted small">Clique em uma palavra para adicioná-la à lista de palavras a serem analisadas.</p>
                            <div>
                              {palavrasDinamicas.map((palavra, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  className="btn btn-sm btn-outline-info mr-2 mb-2"
                                  onClick={() => this.addPalavraDinamicaFinanceira(palavra)}
                                  title={`Adicionar ${palavra.label}`}
                                  disabled={!this.props.finSelected}
                                >
                                  {palavra.label} ({palavra.value})
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <button type="button" className="btn btn-default" onClick={this.handleCancelFinanceira}>
                            {" "}
                            Cancelar
                          </button>
                          <button disabled={!this.props.finSelected} className="btn btn-info" type="submit">
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="hpanel">
                      <div className="panel-heading">
                        <div className="panel-tools"></div>
                        Financeiras Customizadas
                      </div>
                      <div className="panel-body">
                        <div className="table-responsive">
                          {this.props.allFinancial && this.props.allFinancial.length > 0 ? (
                            <table cellPadding="1" cellSpacing="1" className="table table-bordered table-striped">
                              <thead>
                                <tr>
                                  <th className="text-center align-middle">Razão Social</th>
                                  <th className="text-center align-middle">Palavras a Serem Analisadas</th>
                                  <th className="text-center align-middle">Análise Desabilitada</th>
                                  <th className="text-center align-middle" style={{ width: "5%" }}>
                                    Ações
                                  </th>
                                </tr>
                              </thead>
                              <tbody>{this.renderListAllFinancial()}</tbody>
                            </table>
                          ) : (
                            <small>Nenhum registro encontrado</small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListAllFinancial() {
    if (!this.props.allFinancial && !this.props.companies) {
      return;
    }

    let allFinancial = this.props.allFinancial ? this.props.allFinancial : this.props.companies;

    return allFinancial.map((financial, index) => {
      return (
        <tr key={index}>
          <td className="text-center align-middle">{financial.razaoSocial}</td>
          <td className="text-center align-middle">{financial.palavras ? JSON.parse(financial.palavras).join(", ") : "-"}</td>
          <td className="text-center align-middle">{financial.status ? "Sim" : "Não"}</td>
          <td className="align-middle text-center">
            <div className="btn-group">
              <button type="button" className="btn btn-sm btn-default" onClick={this.onDelete(financial)}>
                <i className="fas fa-trash" title="Excluir"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  }
}

const mapDispatchToProps = (dispatch) => ({
  onCompaniesLoad: (payload) => dispatch({ type: ANALISE_IMAGEM_ALL_COMPANIES_LOAD, payload }),
  onFinancialLoad: (payload) => dispatch({ type: ANALISE_IMAGEM_ALL_FINANCIAL_LOAD, payload }),
  onActionOpen: (payload) => dispatch({ type: CONFIRM_ACTION_OPEN, payload }),
});

const selector = formValueSelector("ConfigurarPalavrasForm");
const mapStateToProps = (state) => ({
  ...state.analiseImagem,
  camposFixos: selector(state, "camposFixos"),
  camposFinanceira: selector(state, "camposFinanceira"),
  financeiraDesabilitada: selector(state, "financeiraDesabilitada"),
  finSelected: selector(state, "financeiraSel"),
  currentUser: state.common.currentUser,
  companies: state.common.companies.length > 0 ? state.common.companies : [],
});

const form = reduxForm({
  form: "ConfigurarPalavrasForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(ConfigurarPalavras));
